import { render } from "./Keno.vue?vue&type=template&id=c48a8faa&scoped=true"
import script from "./Keno.vue?vue&type=script&lang=js"
export * from "./Keno.vue?vue&type=script&lang=js"

import "./Keno.vue?vue&type=style&index=0&id=c48a8faa&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48a8faa"]])

export default __exports__